import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  opacity: 0;
  transition: opacity 0.2s ease-in-out;

  .react-grid-item:hover & {
    opacity: 1;
  }
`
